import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { AdminUserResponse, RolName, SoporteArea } from '../interfaces/admin.users.interface';
import { TokenService } from './token.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly API = environment.URL_API;
  private apiURL = `${this.API}/panel-admin/api/v1/users/buscar/usernamev2`;

  constructor(private http: HttpClient, private router: Router, private tokenService: TokenService) {}

  login(username: string, password: string): Observable<any> {
    // return this.http.post(`${this.API}/login`, { username, password }).pipe(tap(() => {localStorage.setItem('username', username)}));
    return this.http.post<any>(`${this.API}/panel-admin/login`, { username, password }).pipe(
      tap((res) => {
        localStorage.setItem('username', username);
        // El token se guarda en localStorage vía TokenService (la sesión sobrevive al F5).
        if (res?.token) {
          this.tokenService.set(res.token);
        }
      })
    );
  }

  logout(): void {
    this.tokenService.clear();
    localStorage.removeItem('username');
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_display_name');
    localStorage.removeItem('sessionUserId');
    localStorage.removeItem('sessionEmail');
    sessionStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  getStoredUsername(): string | null {
    return (localStorage.getItem('username') || sessionStorage.getItem('username'));
  }

  getUserRole(username: string): Observable<RolName> {
    return this.http.get<AdminUserResponse>(`${this.apiURL}/${username}`).pipe(
      map((res) => {
        if (res.name) {
          localStorage.setItem('user_display_name', res.name);
        }

        const userId = res.idUserAdmin;
        const email = res.email;
        if (userId !== undefined && userId !== null) {
          localStorage.setItem('sessionUserId', String(userId));
          localStorage.setItem('sessionEmail', String(email));
        }

        if (res.rolName) {
          localStorage.setItem('user_role', res.rolName);
        }

        return res.rolName;
      })
    );
  }

  getStoredRole(): RolName | null {
    return (localStorage.getItem('user_role') as RolName | null) || null;
  }

  getStoredUserName(): string {
    return localStorage.getItem('user_display_name') || '';
  }

  /** @deprecated Usar getStoredUserName() */
  getStoredEmail(): string {
    return this.getStoredUserName();
  }

getAllowerAreas(rol: RolName): SoporteArea[] {
    switch (rol) {
      case 'ROL_MASTER':
      case 'ROL_MASTER_COORDINADOR':
        return ['LEGAL', 'GENERAL', 'SISTEMAS', 'CONTABILIDAD', 'SUPERVISION', 'GERENCIA', 'CEO'];
      case 'ROL_SOPORTE_COORDINADOR':
        return ['GENERAL', 'SUPERVISION'];
      case 'ROL_CONTABLE':
        return ['CONTABILIDAD'];
      case 'ROL_SOPORTE':
        return ['GENERAL'];
      case 'ROL_LEGAL':
        return ['LEGAL'];
      default:
        return [];
    }
  }
}